import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HowToVoteIcon(props: IconProps) {
    return <Icon {...props} iconKey={"how_to_vote"}/>
}
